function concatHelper(...args) {
  args.pop();
  return args.join("");
}

export default concatHelper;
